module.exports = __webpack_public_path__ + "img/logo.a286d2fc.svg";